import { facility, ActionType } from "./types";

const setFacility = (data: facility) => {
  return {
    type: ActionType.SET_FACILITY,
    payload: data,
  };
};

export default setFacility;
